import React from 'react'
import './AboutHeader.css'
const AboutHeader = () => {
    return (
        <div className="about_header">
            <div className="page-container">
            <h2>About Us</h2>
            <p>We are changing the <span style={{ color: '#757575' }}>narrative of African energy.</span></p>
            </div>
        </div>
    )
}

export default AboutHeader
